module.exports = __webpack_public_path__ + "media/functional__pavlenko.c2bc801c.mp4";